/*=== Этот файл импорта переменных из PHP генерируется скриптом 
getConf.php запускаемым из gulp ===*/
export var PHP = {};
PHP.debug = '0';
PHP.artImgRt = '';
PHP.imgRt = '';
PHP.f1 = '';
PHP.f2 = '';
PHP.f3 = '';
PHP.pgMore = '18';
